import React from "react";
import LanguageTable from "./List/Languagelist";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import "../../../components/common/css/datatable.scss";
import "../../../components/common/css/index.scss";

const Langauge = () => {
  
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <LanguageTable/>
      </div>
    </div>
  );
};

export default Langauge;
